import { RegisterOptions } from 'react-hook-form';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';
import { SsoIdentifierTypes } from 'src/types/Corp';

type UseInternalIdControlWrapperReturn = {
  rules: RegisterOptions;
};

export function useInternalIdControlWrapper(): UseInternalIdControlWrapperReturn {
  const { corpData } = useEmployeeFormContext();
  const { ssoEnabled, ssoIdentifier } = corpData;

  const isRequired =
    ssoEnabled && ssoIdentifier === SsoIdentifierTypes.INTERNAL_ID;

  return {
    rules: {
      ...(isRequired && {
        required: 'Internal ID is required',
      }),
    },
  };
}
